<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>

    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Département(s)</label>

          <Multiselect
            v-model="filters.departments"
            :options="dptOptions"
            label="label"
            track-by="value"
            multiple
          />
        </div>

        <div class="form-group col-sm-6">
          <label>Cible</label>

          <v-select
            v-model="filters.clientType"
            :options="clientTypeOptions"
            :reduce="({ value }) => value"
          ></v-select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-6">
          <label>Coach Manager</label>

          <Multiselect
            placeholder="Choisir un ou des coachs manager"
            v-model="filters.coachManagers"
            :options="coachManagers"
            label="label"
            track-by="label"
            class="custom-multiselect"
            :multiple="true"
          />
        </div>

        <div class="form-group col-sm-6">
          <label>Rechercher un prestataire</label>

          <input
            class="form-control"
            v-model="filters.coach"
            placeholder="Rechercher un prestataire"
          />
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters()"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  components: {
    Multiselect,
  },

  props: {},

  data() {
    return {
      filters: {
        departments: [],
        coachManagers: [],
        coach: "",
        clientType: null,
      },

      coachManagers: [],
      clientTypeOptions: [
        { label: "B2C", value: "isB2C" },
        { label: "B2B", value: "isB2B" },
        { label: "Marchés", value: "marketEstablishment" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      departments: "getDepartments",
    }),

    dptOptions() {
      return this.departments
        .filter((dpt) => dpt.code !== "all")
        .map(({ code, name }) => ({
          label: `${code} - ${name}`,
          value: code,
        }));
    },
  },

  created() {
    this.getCoachManagers();
  },

  methods: {
    async getCoachManagers() {
      const { data } = await this.$api.get("/users/coach-managers");

      this.coachManagers = data.map((coach) => ({
        value: coach.email,
        label: coach.coachManager.pseudo,
        color: coach.coachManager.color,
      }));
    },

    applyFilters() {
      this.$emit("apply", { ...this.filters });
    },
  },
};
</script>
